import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { JSEncrypt} from 'jsencrypt';
import { Router, ActivatedRoute } from '@angular/router';
import { GeneralService } from '../general.service';
import * as GlobalVariables from '../global';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  jwtToken = null;
  roleId;
  color = 'blue';
  mode = 'indeterminate';
  value = 100;
  loading = false;
  showMsg = false;
  orgID: any;
  username: any;
  hide = true;
  password: any;
  hideLogin = true;
  error_disp: any;
  public positionSelectOPS = [];
  public positionSelectOP:  any;
  userOrgRole = [];
  showSelect = false;
  projectUrl: any;
  email: any;
  step1 = true;
  saltRes: any;
  captchaImage: any;
  captchaID: any;
  captcha: any;
  hash1: string;
  ophash1: string;
  version: any;
  lastLoggedOrg: any;
  lastLogedTime: any;
  lastLaggedOrgName: any;
  selected: any;
  opData1: any;
  opData: {
    'name': '',
    'uuid': '',
    'mheAppData': any
  };
  showError: boolean;
  constructor(private router: Router, @Inject(DOCUMENT) document, private route: ActivatedRoute,
    private homepageService: GeneralService, private snackBar: MatSnackBar, private authService: AuthService, private generalService: GeneralService,
    private spinn: NgxSpinnerService) {
      // this.projectUrl = environment.projectUrl;
      this.opData = {
        'name': '',
        'uuid': '',
        'mheAppData': {}
      };
    }
     openNav() {
      document.getElementById('mySidenav').style.width = '190px';
    }

     closeNav() {
      document.getElementById('mySidenav').style.width = '0';
    }
  ngOnInit() {
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem('isUpdate', 'true');
    this.version = environment.version;

  }

  policy() {
    sessionStorage.setItem('external', 'true');
    this.router.navigate(['policy']);
  }

  login() {
    //this.router.navigate(['adminDashboard']);

    if (this.username && this.password) {
      this.showError = false;
      //const encrypt = new JSEncrypt();
      //encrypt.setPublicKey(GlobalVariables.rsapublicKey);
      //const encrypted = encrypt.encrypt(this.password);
      const loginObject = {
        Email: this.username,
        Password: this.password
      };
      this.spinn.show();
      
      this.authService.login(loginObject).subscribe(response => {
        const JWtoken = response.json().token;
        this.jwtToken = response.json().token;
        sessionStorage.setItem('token', JWtoken);
        const helper = new JwtHelperService();
        const decodedToken = helper.decodeToken(JWtoken);
        this.roleId = response.json().roleId;
        sessionStorage.setItem('roleId', response.json().roleId);
        sessionStorage.setItem('userName', response.json().email);
        sessionStorage.setItem('isLoggedIn', 'true');
        sessionStorage.setItem('password', response.json().password);
        sessionStorage.setItem('userID', response.json().email);
        sessionStorage.setItem('userId', response.json().userId);
        sessionStorage.setItem('role', response.json().roleId);
        sessionStorage.setItem('stateId', response.json().stateId);
        sessionStorage.setItem('districtId', response.json().districtId);
        sessionStorage.setItem('talukaId', response.json().talukaId);
        sessionStorage.setItem('chcId', response.json().chcId);
        sessionStorage.setItem('phcId', response.json().phcId);
        sessionStorage.setItem('facilityId', response.json().facilityId);
        sessionStorage.setItem('firstName', response.json().firstName);
        sessionStorage.setItem('lastName', response.json().lastName);
        
          if (this.roleId == '1') {
            //console.log(this.roleId);
            this.router.navigate(['adminDashboard']);
          } else 
          if (this.roleId == '2') {
            this.router.navigate(['distDashboard']);
          // }else if (this.roleId == '3') {
          //   this.router.navigate(['dashboard']);
          // }else if (this.roleId == '4') {
          //   this.router.navigate(['dashboard']);
          // }else if (this.roleId == '5') {
          //   this.router.navigate(['dashboard']);
          // }else if (this.roleId == '6') {
          //   this.router.navigate(['dashboard']);
          // }else if (this.roleId == '9') {
          //   this.router.navigate(['dashboard']);
          // }else if (this.roleId == '11') {
          //   this.router.navigate(['dashboard']);
          // }else if (this.roleId == '12') {
          //   this.router.navigate(['hwcStateDashboard']);
          // }else if (this.roleId == '13') {
          //   this.router.navigate(['distDashboard']);
          // }else if (this.roleId == '14') {
          //   this.router.navigate(['dashboard']);
          // }else if (this.roleId == '15') {
          //   this.router.navigate(['dashboard']);
          // } else if(this.roleId == 16){
          //   this.router.navigate(['dashboard']);
          } else {
            this.router.navigate(['login']);
            this.snackBar.open('Invalid Role', 'x', {
              duration: 5000,
            });
          }
          this.spinn.hide();
      }, (error) => {
          this.spinn.hide();
        this.snackBar.open(error.json().message, 'x', {
          duration: 5000,
        });
      });
    } else {
      this.showError = true;
    }
  }


  getFacilityData(){

    const inputData = {
      facilityId: '2707',
    }

    this.generalService.fectchFacility(inputData).subscribe(response => {

      

    }, (error) => {
      this.spinn.hide();
    this.snackBar.open(error.json().message, 'x', {
      duration: 5000,
    });
  });
  }


  getDistrictData(){
    this.generalService.fectchFacility(null).subscribe(response => {

      

    }, (error) => {
      this.spinn.hide();
    this.snackBar.open(error.json().message, 'x', {
      duration: 5000,
    });
  });
  }

  getTalukaData(){
    this.generalService.fectchFacility(null).subscribe(response => {

      

    }, (error) => {
      this.spinn.hide();
    this.snackBar.open(error.json().message, 'x', {
      duration: 5000,
    });
  });
  }

}
